import type { IntroducingAttributes } from '../../../types/cms'
import { Container, Grid, Box } from '@mui/material'
import { Background } from '../../surfaces/background'
import { MarkdownText } from 'ui-kit'
import IntroducingCard from '../../Cards/IntroducingCard'
import { IntroducingContainer } from './styles'

const Introducing = ({
  title,
  info,
  cards,
  backgroundColour,
  textColour,
}: IntroducingAttributes) => {
  return (
    <>
      <IntroducingContainer
        backgroundColour={backgroundColour}
        textColour={textColour}
      >
        <Container maxWidth="md">
          <MarkdownText>{title}</MarkdownText>
          <Box sx={{ whiteSpace: 'pre-wrap' }}>
            <MarkdownText>{info}</MarkdownText>
          </Box>
        </Container>
      </IntroducingContainer>
      {(cards?.length ?? 0) > 0 && (
        <Background>
          <Container>
            <Grid container spacing={2} sx={{ pb: 6, mx: 'auto', mt: 6 }}>
              {cards?.map(({ title: cardTitle, info: cardInfo, image }) => (
                <IntroducingCard
                  key={cardTitle}
                  title={cardTitle}
                  info={cardInfo}
                  image={image}
                />
              ))}
            </Grid>
          </Container>
        </Background>
      )}
    </>
  )
}

export default Introducing
